export default __webpack_public_path__ + "static/media/banque.00368c2f.svg";